import React from "react";
import axios from "axios";
import config from "LIBRARY/config";
import { Base64 } from 'js-base64';

class LibraryApiCall extends React.Component {
    
    static async makeLibraryApiCall(type, info, url) {
        let apiResult = { success: false, APIResult: {}, expired: false };
        let formdata = new FormData();
        formdata.append(type, true);
        formdata.append('data', Base64.encode(JSON.stringify(info)));
        await axios({
            method: "post",
            url: config.RootUrl + url,
            data: formdata,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            },
        }).then((response) => {
            let jsonResponse = response.data;
            if (jsonResponse.success == 'true') {
                apiResult.success = true;
                apiResult.APIResult = jsonResponse;
            }else {
                apiResult.success = false;
                apiResult.APIResult = jsonResponse;
            }

        }).catch(err => console.log("Library error", err))

        return apiResult;
    }
}

export default LibraryApiCall;